export default __webpack_public_path__ + "0fc44a649914c1d98a34aced4b922ec2.svg";